import moment from 'moment';
import { DateType } from 'api/models';
import { ProjectPhase } from 'api/project';
import { Task } from 'api/tasks';
import { humanise } from 'components/atoms/humanised-date';

type DateParam = DateType | undefined | null;
type ToReadableDatesFunc = (dates: [DateParam, DateParam]) => string;

export const toReadableDates: ToReadableDatesFunc = (dates) =>
  (dates.filter(Boolean) as DateType[])
    .map((date) => humanise(moment(date)))
    .join(' - ');

type GetExpectedPhaseDatesFunc = (
  projectPhase: Pick<ProjectPhase, 'startDate' | 'dueDate'>,
  task: Pick<Task, 'startDate' | 'dueDate'>,
) => [DateType, DateType];

export const getExpectedPhaseDates: GetExpectedPhaseDatesFunc = (
  projectPhase,
  task,
) => {
  return [
    task.startDate
      ? task.startDate < projectPhase.startDate
        ? task.startDate
        : projectPhase.startDate
      : projectPhase.startDate,
    task.dueDate
      ? task.dueDate > projectPhase.dueDate
        ? task.dueDate
        : projectPhase.dueDate
      : projectPhase.dueDate,
  ];
};
